/** API route map: URLS.Controller.OfferLetter */
export const OfferLetter = {
      Name: 'OfferLetter/',
      GetAll: 'getall',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
      GetClientList: 'getclientList',
};
